import React from 'react';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { reportActions } from '../../store/reportStore';
import { withLocalize, Translate } from 'react-localize-redux';
import OldStyleSubsection from '../common/oldStyleSubsection';
import OldStyleTableWithHistory from '../common/oldStyleTableWithHistory';
import OldStyleSection from '../common/oldStyleSection';
import ExcelExportButton from '../common/excelExportButton';
import CustomTooltip from "../common/customTooltip";
import AddressRow from './identData/addressRow';
import BasicRow from './identData/basicRow';
import HistoryRow from './identData/historyRow';

class OrsrDataRecap extends React.Component {
    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {

        const { data } = this.props.sections.find(o => o.id === this.props.sectionId);
        return (data === undefined || data === null ? null : this.renderContent());
    }

    renderContent = () => {
        var subsections = this.props.sections.find(s => s.id === this.props.sectionId).subsections;
        let activities = this.props.data.activity;
        let identification = this.props.data.identification;
        let otherLegalFacts = this.props.data.otherLegalFacts;
        return (
            <div>
                {this.renderIdentSection(identification)}
                {this.renderActivitiesSection(activities)}
                {this.renderRelationsCSRD(subsections)}
                {this.renderOtherLegalFactsSection(otherLegalFacts)}
            </div>
        );
    }

    renderIdentSection = (identification) => {
        return <>
            {!isNullOrUndefined(identification) &&
                <><OldStyleSection isBold hasData
                    name={this.props.translate("Report.CompanyIdentification.SectionName")}>
                    <div style={{ paddingTop: "0.25em" }}>
                        <div className="ident-data">
                            <HistoryRow name={identification.companyName} from={identification.from} source={identification.companyNameSource} SourceFullCompany={identification.companyNameSource} primaryNamesUngrouped={identification.primaryNamesUngrouped} historyNames={identification.historyNames} primaryNames={identification.primaryNames} />
                            <AddressRow address={identification.fullAddress} addressSource={identification.fullAddressSource} historyAddresses={identification.historyAddresses} sourceFullName={identification.SourceFullName} primaryAddressFrom={identification.fullAddressFrom} />
                            <BasicRow title="Report.CompanyIdentification.LegalForm" value={identification.legalForm} />
                            <BasicRow title="Report.CompanyIdentification.FactWording" value={identification.factWording} />
                            <BasicRow title="Report.CompanyIdentification.Ico" value={identification.companyId} />
                        </div>
                    </div>
                </OldStyleSection></>}
        </>
    }

    renderActivitiesSection = (activities) => {
        return !isNullOrUndefined(activities) &&
            <><OldStyleSection isBold hasData
                name={this.props.translate("Report.SubjectActivitySk.SectionName")}>
                <div style={{ paddingTop: "0.25em" }}>
                    {this.renderActivityTable(activities)}
                </div>
            </OldStyleSection></>
    }

    renderRelationsCSRD = (subsections) => {
        return <OldStyleSection isBold hasData
            name={this.props.translate("Report.RelationsCRSR.SectionName")}>
            <div style={{ marginLeft: '2.5em', paddingTop: '0.25em' }}>
                {subsections.map(s => <OldStyleSubsection isBold
                    key={s.id}
                    sectionId={this.props.sectionId}
                    subsectionId={s.id}
                    subsectionName={s.Name}
                    subsectionData={{ type: s.params.type }}
                    style={{ paddingTop: '1em' }}
                />)}
                <ExcelExportButton link="relations-crsr" entityId={this.props.id} report={this.props.reportType} />
            </div>
        </OldStyleSection>
    }

    renderOtherLegalFactsSection = (otherLegalFacts) => {
        return !isNullOrUndefined(otherLegalFacts) && <OldStyleSection isBold hasData
            name={this.props.translate("Report.OtherLegalFacts.SectionName")}>
            {this.renderOtherLegalFactsTable(otherLegalFacts)}
        </OldStyleSection>
    }

    renderOtherLegalFactsTable = (data) => {
        const historical = data.filter(x => x.inactivityIndicatorId !== '00');
        const active = data.filter(x => x.inactivityIndicatorId !== '01');

        return (
            <>
                <OldStyleTableWithHistory
                    offsetLeft={false}
                    head={() => this.renderHeadForOtherLegalFacts()} tableColumns={3} stripped
                    actualData={active} actualRow={(r) => this.renderRowForOtherLegalFacts(r)}
                    historyData={historical} historyRow={(r) => this.renderRowForOtherLegalFacts(r, true)}
                    resolveExpanded={this.props.resolveExpanded}
                />
            </>
        );
    }

    renderHeadForOtherLegalFacts = () => {
        return (
            <thead>
                <tr>
                    <th style={{ width: "60%", textAlign: "center" }}>Popis</th>
                    <th style={{ width: "20%", textAlign: "right" }}>Platné od</th>
                    <th style={{ width: "20%", textAlign: 'right' }}>Platné do</th>
                </tr>
            </thead>
        );
    }

    renderRowForOtherLegalFacts = (a, isHistory = false) => {
        return (
            <tr key={a.id} className={classnames("colorize", { "old-style-table-report-history-row": isHistory })}>
                <td className="always-new-line" style={{ fontWeight: "normal" }}>{a.factWording}</td>
                <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>{a.startDateFormatted}</td>
                <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>{isHistory ? a.endDateFormatted : null}</td>
            </tr>
        );
    }

    renderActivityTable = (data) => {
        const historical = data.activities.filter(x => x.to !== null);
        const active = data.activities.filter(x => x.to === null);
        return (
            <>
                <OldStyleTableWithHistory
                    offsetLeft={false}
                    head={() => this.renderHead()} tableColumns={4} stripped
                    actualData={active} actualRow={(r) => this.renderRow(r, "activity")}
                    historyData={historical} historyRow={(r) => this.renderRow(r, "activityHistory", true)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                <ExcelExportButton link="subject-activity" entityId={this.props.id} report={this.props.reportType} />
            </>
        );
    }


    renderRow = (a, prefix, isHistory = false) => {
        return (
            <tr key={a.rowId} className={classnames("colorize", { "old-style-table-report-history-row": isHistory })}>
                <td style={{ fontWeight: "normal" }} className="always-new-line">{a.activity}</td>
                <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>{a.fromFormated}</td>
                <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>{isHistory ? a.toFormated : null}</td>
                <td style={{ textAlign: 'right' }} id={prefix + a.rowId}>{a.source}
                    <CustomTooltip textAlign="right" placement='left' id={prefix + a.rowId} text={a.sourceDescription} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                    </CustomTooltip>
                </td>
            </tr>
        );
    }

    renderHead = () => {
        return (
            <thead>
                <tr>
                    <th><Translate id="Report.Common.Title" /></th>
                    <th className="col-3" style={{ textAlign: "right" }}><Translate id="Report.Common.From" /></th>
                    <th className="col-3" style={{ textAlign: "right" }}><Translate id="Report.Common.To" /></th>
                    <th className="col-3" style={{ textAlign: 'right' }}><Translate id="Report.Common.Source" /></th>
                </tr>
            </thead>
        );
    }
}

export default withLocalize(connect(
    state => ({ ...state.report }),
    dispatch => bindActionCreators(reportActions, dispatch)
)(OrsrDataRecap));

